'use strict';

(function (window) {
    app.controller('modalOutboundPrintOptionCtrl', function ($scope, $uibModalInstance, params) {
        $scope.entryLabel = params && params.entryLabel ? params.entryLabel : 'Outbound';
        $scope.awb = params && params.awb ? params.awb : '';

        $scope.choose = function (mode) {
            $uibModalInstance.close({
                mode: mode || 'standard'
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

    window.registerOutboundEntryController = function registerOutboundEntryController(controllerName, options) {
        var config = angular.extend({
            isEWaybillMode: false,
            allowReceiverCustomerLookup: false,
            showReceiverCustomerCodeField: false,
            showUploadButton: false,
            entryLabel: 'Outbound',
            saveHeaderText: 'Simpan Outbound',
            deleteHeaderText: 'Hapus Outbound',
            defaultDataUrl: '/outbound-entry-defaultdata',
            entryDataUrl: '/outbound-entry-data/',
            printUrl: '/outbound-print',
            apiBaseUrl: 'api/outbound',
            generateAwbUrl: 'api/outbound/generate-awb',
            chargePreviewUrl: 'api/outbound/charge-preview',
            shipperCustomerListUrl: 'api/outbound/customer-list?',
            shipperCustomerLookupUrl: 'api/outbound/customer-code/',
            receiverCustomerListUrl: 'api/outbound/customer-list?',
            receiverCustomerLookupUrl: 'api/outbound/customer-code/',
            uploadModalTitle: 'Upload E-Waybill',
            uploadTemplateUrl: '',
            uploadPrecheckUrl: '',
            uploadUrl: '',
            deleteDeniedMessage: 'Anda tidak memiliki otoritas hapus outbound'
        }, options || {});

        app.controller(controllerName, function ($rootScope, $scope, $state, $filter, $stateParams, shareData, uuid, urlServices, toaster, modalFactory, modalService, $timeout, $element) {
            var lastLookupAwb = null;
            var shipmentChargeLookupTimer = null;
            var shipperLookupTimer = null;
            var consignLookupTimer = null;
            var cityLookupTimers = {
                origin: null,
                destination: null
            };
            var numberInputGuardCleanup = null;
            var autoAwbState = {
                valid: !config.isEWaybillMode,
                message: ''
            };

            function chooseDeleteReason(title, awb, callback) {
                modalFactory.open('md', 'modal.delete-awb-reason.html', 'modalDeleteAwbReasonCtrl', {
                    title: title,
                    entryLabel: config.entryLabel,
                    awb: awb
                }).result.then(function (payload) {
                    return callback(null, payload && payload.reason ? payload.reason : '');
                }, function () {
                    return callback(null, null);
                });
            }

            if ($rootScope.globalFormatDateRangePickerSingleTimeOption && $rootScope.globalFormatDateRangePickerSingleTimeOption.minDate) {
                delete $rootScope.globalFormatDateRangePickerSingleTimeOption.minData;
            }

            $scope.isEWaybillMode = !!config.isEWaybillMode;
            $scope.allowReceiverCustomerLookup = !!config.allowReceiverCustomerLookup;
            $scope.showReceiverCustomerCodeField = !!config.showReceiverCustomerCodeField;
            $scope.showUploadButton = !!config.showUploadButton;
            $scope.entryLabel = config.entryLabel;
            $scope.formNotice = null;
            $scope.isReadOnly = false;
            $scope.isEdit = false;
            $scope.isAutoNumber = false;
            $scope.loadingData = false;
            $scope.saving = false;
            $scope.checkingAwb = false;
            $scope.deleteAuthorized = false;
            $scope.isWeightMetricManual = false;
            $scope.isChargeShipmentManual = false;
            $scope.suspendShipmentChargeLookup = false;
            $scope.originalAwb = null;
            $scope.currentAwbStatus = null;
            $scope.dataOutbound = {};
            $scope.detailItem = [];
            $scope.volumeRows = [];
            $scope.showItemsSection = false;
            $scope.paymentOptions = [
                { PaymentName: 'CASH' },
                { PaymentName: 'CREDIT' }
            ];
            $scope.collectOptions = [
                { value: 'CASH', label: 'CASH' },
                { value: 'COLLECT', label: 'COLLECT' }
            ];
            $scope.shipDatePickerOptions = angular.extend({}, $rootScope.globalFormatDateRangePickerSingle || {}, {
                singleDatePicker: true,
                timePicker: false,
                timePicker24Hour: false
            });
            $scope.pickupDatePickerOptions = angular.extend({}, $rootScope.globalFormatDateRangePickerSingleTimeOption || {}, {
                singleDatePicker: true,
                timePicker: true,
                timePicker24Hour: true
            });

            function setFormNotice(type, message) {
                $scope.formNotice = {
                    type: type,
                    message: message
                };
            }

            function clearFormNotice() {
                $scope.formNotice = null;
            }

            function setAutoAwbState(valid, message) {
                autoAwbState = {
                    valid: !!valid,
                    message: message || ''
                };
                $scope.autoAwbState = angular.extend({}, autoAwbState);
            }

            function getTextFieldLengthError() {
                var checks = [
                    { key: 'shipper_name', label: 'Nama pengirim', max: 200 },
                    { key: 'shipper_address', label: 'Alamat pengirim', max: 250 },
                    { key: 'shipper_inst', label: 'Instruction', max: 150 },
                    { key: 'consign_name', label: 'Nama penerima', max: 100 },
                    { key: 'consign_address', label: 'Alamat penerima', max: 250 },
                    { key: 'isi', label: 'Keterangan penerima', max: 250 }
                ];
                var index;
                var check;
                var value;

                for (index = 0; index < checks.length; index += 1) {
                    check = checks[index];
                    value = String(($scope.dataOutbound && $scope.dataOutbound[check.key]) || '');
                    if (value.length > check.max) {
                        return check.label + ' maksimal ' + check.max + ' karakter';
                    }
                }

                return null;
            }

            function extractMomentValue(value) {
                var stringValue;
                var parsedValue;

                if (!value) {
                    return null;
                }
                if (moment.isMoment(value)) {
                    return value.clone();
                }
                if (value._isAMomentObject) {
                    return moment(value);
                }
                if (value.startDate) {
                    return extractMomentValue(value.startDate);
                }
                if (value._d) {
                    return moment(value._d);
                }

                if (Object.prototype.toString.call(value) === '[object Date]') {
                    parsedValue = moment(value);
                    return parsedValue.isValid() ? parsedValue : null;
                }

                stringValue = String(value).trim();
                if (!stringValue) {
                    return null;
                }

                parsedValue = moment(stringValue, [
                    moment.ISO_8601,
                    'YYYY-MM-DD HH:mm:ss',
                    'YYYY-MM-DD HH:mm',
                    'YYYY-MM-DD',
                    'YYYY/MM/DD HH:mm:ss',
                    'YYYY/MM/DD HH:mm',
                    'YYYY/MM/DD',
                    'DD/MM/YYYY HH:mm:ss',
                    'DD/MM/YYYY HH:mm',
                    'DD/MM/YYYY',
                    'DD-MM-YYYY HH:mm:ss',
                    'DD-MM-YYYY HH:mm',
                    'DD-MM-YYYY',
                    'MM/DD/YYYY HH:mm:ss',
                    'MM/DD/YYYY HH:mm',
                    'MM/DD/YYYY'
                ], true);

                if (!parsedValue.isValid()) {
                    parsedValue = moment(value);
                }

                return parsedValue.isValid() ? parsedValue : null;
            }

            function serializeDateValue(value, withTime) {
                var dateValue = extractMomentValue(value);

                if (!dateValue || !dateValue.isValid()) {
                    return '';
                }
                return withTime ? dateValue.format('YYYY-MM-DD HH:mm:ss') : dateValue.format('YYYY-MM-DD');
            }

            function parseIncomingDateValue(value) {
                var dateValue;

                if (value === undefined || value === null || value === '') {
                    return null;
                }

                dateValue = extractMomentValue(value);
                if (dateValue && dateValue.isValid()) {
                    return dateValue.toDate();
                }
                return null;
            }

            function getSafeDateValue(primaryValue, fallbackValue) {
                return parseIncomingDateValue(primaryValue) || parseIncomingDateValue(fallbackValue) || moment().toDate();
            }

            function formatControlDateValue(value, withTime) {
                var dateValue = extractMomentValue(value);

                if (!dateValue || !dateValue.isValid()) {
                    return '';
                }

                return withTime ? dateValue.format('DD/MM/YYYY HH:mm') : dateValue.format('DD/MM/YYYY');
            }

            function focusAwbInput() {
                if ($scope.isEWaybillMode) {
                    return;
                }
                window.setTimeout(function () {
                    var awbInput = document.getElementById('awb');
                    if (awbInput && typeof awbInput.focus === 'function') {
                        awbInput.focus();
                    }
                }, 0);
            }

            function createEmptyItem(sn) {
                return {
                    item_code: '',
                    desc: '',
                    sn: String(sn || ''),
                    qty: null,
                    uom: $scope.dataOutbound.uom || '',
                    qty_box: null,
                    weight: null,
                    notes: ''
                };
            }

            function normalizeAwbValue(value) {
                return String(value || '').trim().toUpperCase();
            }

            function normalizeTextValue(value) {
                return String(value === undefined || value === null ? '' : value).trim();
            }

            function normalizeCodeValue(value) {
                return normalizeTextValue(value).toUpperCase();
            }

            function applySelectedCustomer(args) {
                var customerName = normalizeTextValue(args && (args.CustomerName || args.customerName));
                var customerAddress = normalizeTextValue(args && (args.Address || args.address));
                var customerPhone = normalizeTextValue(args && (args.Phone || args.phone));
                var customerFax = normalizeTextValue(args && (args.Fax || args.fax || args.PU_Fax || args.pu_fax));
                var customerContact = normalizeTextValue(args && (args.Contact || args.contact || args.PU_Name || args.pu_name));

                if (args && args.isReceiver) {
                    $scope.dataOutbound.consign_code = normalizeCodeValue(args && args.CustomerCode);
                    $scope.dataOutbound.consign_name = customerName;
                    $scope.dataOutbound.consign_address = customerAddress;
                    $scope.dataOutbound.consign_phone = customerPhone;
                    $scope.dataOutbound.consign_fax = customerFax;
                    $scope.dataOutbound.consign_attn = customerContact;
                    return;
                }

                $scope.dataOutbound.shipper_code = normalizeCodeValue(args && args.CustomerCode);
                $scope.dataOutbound.shipper_name = customerName;
                $scope.dataOutbound.shipper_address = customerAddress;
                $scope.dataOutbound.shipper_contact = customerContact;
                $scope.dataOutbound.shipper_phone = customerPhone;
                $scope.dataOutbound.shipper_fax = customerFax;
                $scope.dataOutbound.is_ppn = args && args.ISPPN ? 1 : 0;
                recalculateCharges();
                if ($scope.isEWaybillMode && !$scope.isEdit) {
                    requestGeneratedAwb(null, true);
                }
            }

            function clearSelectedCustomer(isReceiver) {
                if (isReceiver) {
                    $scope.dataOutbound.consign_name = '';
                    $scope.dataOutbound.consign_address = '';
                    $scope.dataOutbound.consign_phone = '';
                    $scope.dataOutbound.consign_fax = '';
                    $scope.dataOutbound.consign_attn = '';
                    return;
                }

                $scope.dataOutbound.shipper_name = '';
                $scope.dataOutbound.shipper_address = '';
                $scope.dataOutbound.shipper_contact = '';
                $scope.dataOutbound.shipper_phone = '';
                $scope.dataOutbound.shipper_fax = '';
                if ($scope.isEWaybillMode && !$scope.isEdit) {
                    $scope.dataOutbound.awb = '';
                    setAutoAwbState(false, 'Id Pengirim harus dipilih sebelum generate AWB');
                }
            }

            function lookupCustomerByCode(code, isReceiver, immediate) {
                var lookupUrl = isReceiver ? config.receiverCustomerLookupUrl : config.shipperCustomerLookupUrl;
                var lookupTimer = isReceiver ? consignLookupTimer : shipperLookupTimer;
                var scrollPosition = immediate ? captureScrollPosition() : null;

                if (lookupTimer) {
                    $timeout.cancel(lookupTimer);
                }

                code = normalizeCodeValue(code);
                if (isReceiver) {
                    $scope.dataOutbound.consign_code = code;
                } else {
                    $scope.dataOutbound.shipper_code = code;
                }

                if (!code) {
                    return;
                }

                lookupTimer = $timeout(function () {
                    if (!lookupUrl) {
                        return;
                    }

                    urlServices.ambilData(lookupUrl + encodeURIComponent(code), {}, function (err, result) {
                        var exactMatch = null;

                        if (err) {
                            return;
                        }

                        if (result && result.CustomerCode) {
                            exactMatch = result;
                        } else if (result && result.dt && result.dt.CustomerCode) {
                            exactMatch = result.dt;
                        } else if (angular.isArray(result) && result.length > 0) {
                            exactMatch = result[0];
                        }

                        if (exactMatch) {
                            if (isReceiver) {
                                exactMatch.isReceiver = true;
                            }
                            applySelectedCustomer(exactMatch);
                        } else if (immediate) {
                            clearSelectedCustomer(isReceiver);
                            toaster.pop('warning', config.entryLabel, isReceiver ? 'Id Penerima tidak ditemukan' : ($scope.isEWaybillMode ? 'Id Pengirim tidak ditemukan atau tidak terotorisasi untuk user ini' : 'Id Pengirim tidak ditemukan'));
                        }

                        restoreScrollPosition(scrollPosition);
                    });
                }, immediate ? 0 : 300);

                if (isReceiver) {
                    consignLookupTimer = lookupTimer;
                } else {
                    shipperLookupTimer = lookupTimer;
                }
            }

            function lookupShipperByCode(immediate) {
                lookupCustomerByCode($scope.dataOutbound.shipper_code, false, immediate);
            }

            function lookupConsignByCode(immediate) {
                if (!$scope.allowReceiverCustomerLookup) {
                    return;
                }

                lookupCustomerByCode($scope.dataOutbound.consign_code, true, immediate);
            }

            function applyCityLookupResult(isFrom, city) {
                if (isFrom) {
                    $scope.dataOutbound.org_code = normalizeCodeValue(city && city.CityCode);
                    $scope.dataOutbound.org_name = normalizeTextValue(city && city.CityName);
                    $scope.dataOutbound.org_host_code = normalizeCodeValue(city && city.HostCode);
                    $scope.dataOutbound.org_host_name = normalizeTextValue(city && city.HostName);
                } else {
                    $scope.dataOutbound.dest_code = normalizeCodeValue(city && city.CityCode);
                    $scope.dataOutbound.dest_name = normalizeTextValue(city && city.CityName);
                    $scope.dataOutbound.dest_host_code = normalizeCodeValue(city && city.HostCode);
                    $scope.dataOutbound.dest_host_name = normalizeTextValue(city && city.HostName);
                }
            }

            function clearCityLookupResult(isFrom) {
                if (isFrom) {
                    $scope.dataOutbound.org_name = '';
                    $scope.dataOutbound.org_host_code = '';
                    $scope.dataOutbound.org_host_name = '';
                } else {
                    $scope.dataOutbound.dest_name = '';
                    $scope.dataOutbound.dest_host_code = '';
                    $scope.dataOutbound.dest_host_name = '';
                }
            }

            function lookupCityByCode(isFrom, immediate) {
                var code = normalizeCodeValue(isFrom ? $scope.dataOutbound.org_code : $scope.dataOutbound.dest_code);
                var timerKey = isFrom ? 'origin' : 'destination';
                var scrollPosition = immediate ? captureScrollPosition() : null;

                if (cityLookupTimers[timerKey]) {
                    $timeout.cancel(cityLookupTimers[timerKey]);
                }

                if (isFrom) {
                    $scope.dataOutbound.org_code = code;
                } else {
                    $scope.dataOutbound.dest_code = code;
                }

                if (!code) {
                    clearCityLookupResult(isFrom);
                    return;
                }

                cityLookupTimers[timerKey] = $timeout(function () {
                    urlServices.ambilData('api/destination?term=' + encodeURIComponent(code) + '&limit=20&pg=1', {}, function (err, result) {
                        var rows = [];
                        var exactMatch = null;

                        if (err) {
                            clearCityLookupResult(isFrom);
                            restoreScrollPosition(scrollPosition);
                            return;
                        }

                        if (result && result.dt) {
                            rows = result.dt;
                        } else if (angular.isArray(result)) {
                            rows = result;
                        }

                        angular.forEach(rows, function (item) {
                            if (!exactMatch && normalizeCodeValue(item && item.CityCode) === code) {
                                exactMatch = item;
                            }
                        });

                        if (!exactMatch && rows.length === 1) {
                            exactMatch = rows[0];
                        }

                        if (exactMatch) {
                            applyCityLookupResult(isFrom, exactMatch);
                        } else if (immediate) {
                            clearCityLookupResult(isFrom);
                        }

                        restoreScrollPosition(scrollPosition);
                    });
                }, immediate ? 0 : 300);
            }

            function normalizeEnumValue(value, fallback) {
                var normalized = normalizeTextValue(value).toUpperCase();

                if (!normalized && fallback !== undefined) {
                    return normalizeEnumValue(fallback);
                }
                return normalized;
            }

            function derivePaymentType(typeValue) {
                var normalizedType = normalizeEnumValue(typeValue);

                if (normalizedType.indexOf('CASH') >= 0) {
                    return 'CASH';
                }
                return 'CREDIT';
            }

            function deriveOutboundType(paymentValue, currentType) {
                var normalizedType = normalizeTextValue(currentType);
                var normalizedPayment;

                if (normalizedType) {
                    return normalizedType;
                }

                normalizedPayment = normalizeEnumValue(paymentValue, 'CREDIT');
                return normalizedPayment === 'CASH' ? 'CASH SALES' : 'CREDIT SALES';
            }

            function canonicalizeOptionValue(value) {
                return normalizeEnumValue(value).replace(/\s+/g, ' ');
            }

            function normalizeNumberValue(value) {
                var parsed = Number(value);
                return isNaN(parsed) ? 0 : parsed;
            }

            function normalizeNullableNumberValue(value) {
                if (value === '' || value === null || value === undefined) {
                    return '';
                }

                value = Number(value);
                return isNaN(value) ? '' : value;
            }

            function isStepNumberInput(target) {
                return !!(target && String(target.tagName || '').toUpperCase() === 'INPUT' && String(target.type || '').toLowerCase() === 'number');
            }

            function bindNumberInputGuards() {
                var rootElement = $element && $element[0];

                function handleWheel(event) {
                    var target = event && event.target;

                    if (!isStepNumberInput(target) || document.activeElement !== target) {
                        return;
                    }

                    if (typeof event.preventDefault === 'function') {
                        event.preventDefault();
                    }
                    if (target && typeof target.blur === 'function') {
                        target.blur();
                    }
                }

                function handleKeydown(event) {
                    var target = event && event.target;
                    var key = event && (event.key || event.code || '');

                    if (!isStepNumberInput(target)) {
                        return;
                    }
                    if (key === 'ArrowUp' || key === 'ArrowDown') {
                        event.preventDefault();
                    }
                }

                if (!rootElement || numberInputGuardCleanup) {
                    return;
                }

                rootElement.addEventListener('wheel', handleWheel, true);
                rootElement.addEventListener('keydown', handleKeydown, true);

                numberInputGuardCleanup = function () {
                    rootElement.removeEventListener('wheel', handleWheel, true);
                    rootElement.removeEventListener('keydown', handleKeydown, true);
                    numberInputGuardCleanup = null;
                };

                $scope.$on('$destroy', function () {
                    if (numberInputGuardCleanup) {
                        numberInputGuardCleanup();
                    }
                });
            }

            function captureScrollPosition() {
                if (typeof window === 'undefined') {
                    return null;
                }

                return {
                    x: window.pageXOffset || window.scrollX || 0,
                    y: window.pageYOffset || window.scrollY || 0
                };
            }

            function restoreScrollPosition(position) {
                if (!position || typeof window === 'undefined' || typeof window.scrollTo !== 'function') {
                    return;
                }

                $timeout(function () {
                    window.scrollTo(position.x, position.y);
                }, 0, false);
            }

            function roundCurrencyValue(value) {
                return Math.round(normalizeNumberValue(value));
            }

            function roundMetricValue(value) {
                return Number(normalizeNumberValue(value).toFixed(2));
            }

            function getVolumeDivider(modtrans) {
                var mode = String(modtrans || '').toUpperCase();

                if (mode === 'LAND') {
                    return 4000;
                }
                if (mode === 'SEA') {
                    return 10000;
                }
                return 6000;
            }

            function calculateWeightMetric(row) {
                var pValue = normalizeNumberValue(row.p);
                var lValue = normalizeNumberValue(row.l);
                var tValue = normalizeNumberValue(row.t);
                var divider = getVolumeDivider($scope.dataOutbound.modtrans);

                if (!pValue || !lValue || !tValue || !divider) {
                    return 0;
                }
                return roundMetricValue((pValue * lValue * tValue) / divider);
            }

            function normalizeDetailItem(item, index) {
                return {
                    item_code: item.ItemCode || item.item_code || '',
                    desc: item.Description || item.desc || '',
                    sn: String(item.SN || item.sn || (index + 1)),
                    qty: normalizeNumberValue(item.Qty || item.qty),
                    uom: item.UOM || item.uom || $scope.dataOutbound.uom || '',
                    qty_box: normalizeNumberValue(item.QtyBox || item.qty_box),
                    weight: normalizeNumberValue(item.Weight || item.weight),
                    notes: item.Notes || item.notes || ''
                };
            }

            function normalizeVolumeRow(row, index) {
                var normalized = {
                    awb: normalizeAwbValue(row.AWB || row.awb || $scope.dataOutbound.awb),
                    p: normalizeNullableNumberValue(row.P !== undefined ? row.P : row.p),
                    l: normalizeNullableNumberValue(row.L !== undefined ? row.L : row.l),
                    t: normalizeNullableNumberValue(row.T !== undefined ? row.T : row.t),
                    weightMetric: normalizeNumberValue(row.Weight_Metric || row.weight_metric || row.weightMetric),
                    noOfCollie: normalizeNumberValue(row.NoOfCollie || row.no_of_collie || row.noOfCollie || (index + 1)),
                    collie: normalizeNumberValue(row.Collie || row.collie || $scope.dataOutbound.collie)
                };

                if (!normalized.weightMetric && (normalized.p || normalized.l || normalized.t)) {
                    normalized.weightMetric = calculateWeightMetric(normalized);
                }

                return normalized;
            }

            function serializeVolumeRow(row, index) {
                var normalized = normalizeVolumeRow(row, index);

                normalized.p = normalizeNumberValue(normalized.p);
                normalized.l = normalizeNumberValue(normalized.l);
                normalized.t = normalizeNumberValue(normalized.t);

                return normalized;
            }

            function resequenceDetailItems() {
                $scope.detailItem = ($scope.detailItem || []).map(function (item, index) {
                    var normalized = normalizeDetailItem(item, index);

                    if (!normalized.sn) {
                        normalized.sn = String(index + 1);
                    }
                    return normalized;
                });
            }

            function recalculateVolumeTotals(options) {
                var totalWeightMetric = 0;
                var totalCollie = normalizeNumberValue($scope.dataOutbound.collie);
                var preserveManual = options && options.preserveManual && $scope.isWeightMetricManual;

                $scope.volumeRows = ($scope.volumeRows || []).map(function (row, index) {
                    var normalized = normalizeVolumeRow(row, index);

                    normalized.awb = normalizeAwbValue($scope.dataOutbound.awb) || normalized.awb;
                    normalized.noOfCollie = normalized.noOfCollie || (index + 1);
                    normalized.collie = totalCollie || normalized.collie || $scope.volumeRows.length;
                    totalWeightMetric += normalizeNumberValue(normalized.weightMetric);
                    return normalized;
                });

                if (!preserveManual) {
                    $scope.dataOutbound.weight_metrik = roundMetricValue(totalWeightMetric);
                }
            }

            function buildDefaultVolumeRow(index, rowCount) {
                var totalWeightMetric = normalizeNumberValue($scope.dataOutbound.weight_metrik);
                var row = {
                    awb: normalizeAwbValue($scope.dataOutbound.awb),
                    p: normalizeNullableNumberValue($scope.dataOutbound.l),
                    l: normalizeNullableNumberValue($scope.dataOutbound.w),
                    t: normalizeNullableNumberValue($scope.dataOutbound.h),
                    weightMetric: rowCount > 0 ? roundMetricValue(totalWeightMetric / rowCount) : 0,
                    noOfCollie: index + 1,
                    collie: normalizeNumberValue($scope.dataOutbound.collie) || rowCount
                };

                if (!row.weightMetric) {
                    row.weightMetric = calculateWeightMetric(row);
                }

                return row;
            }

            function refreshVolumeRows(rowsOverride, options) {
                var totalCollie = normalizeNumberValue($scope.dataOutbound.collie);
                var rowCount = totalCollie > 0 ? totalCollie : 1;
                var sourceRows = angular.isArray(rowsOverride) ? rowsOverride : $scope.volumeRows;
                var rows = [];
                var index;

                if (options && options.resetManual) {
                    $scope.isWeightMetricManual = false;
                }

                for (index = 0; index < rowCount; index += 1) {
                    if (sourceRows && sourceRows[index]) {
                        rows.push(normalizeVolumeRow(sourceRows[index], index));
                    } else {
                        rows.push(buildDefaultVolumeRow(index, rowCount));
                    }
                }

                $scope.volumeRows = rows;
                recalculateVolumeTotals(options);
            }

            function getOptionValue(option, keys) {
                var index;

                if (!option) {
                    return '';
                }
                if (!angular.isArray(keys) || keys.length === 0) {
                    return normalizeTextValue(option);
                }
                for (index = 0; index < keys.length; index += 1) {
                    if (option[keys[index]] !== undefined && option[keys[index]] !== null && option[keys[index]] !== '') {
                        return normalizeTextValue(option[keys[index]]);
                    }
                }
                return '';
            }

            function getFirstOptionValue(options, keys) {
                if (!angular.isArray(options) || options.length === 0) {
                    return '';
                }
                return getOptionValue(options[0], keys);
            }

            function getPreferredOptionValue(options, keys, preferredValue) {
                var preferred = findMatchingOptionValue(preferredValue, options, keys);

                if (preferred) {
                    return preferred;
                }
                return getFirstOptionValue(options, keys);
            }

            function findMatchingOptionValue(currentValue, options, keys) {
                var normalizedCurrent = canonicalizeOptionValue(currentValue);
                var index;
                var optionValue;

                if (!normalizedCurrent || !angular.isArray(options)) {
                    return '';
                }
                for (index = 0; index < options.length; index += 1) {
                    optionValue = getOptionValue(options[index], keys);
                    if (canonicalizeOptionValue(optionValue) === normalizedCurrent) {
                        return optionValue;
                    }
                }
                return '';
            }

            function reconcileOutboundSelections() {
                var distServices = ($scope.defaultData && $scope.defaultData.distServices) || [];
                var uomList = ($scope.defaultData && $scope.defaultData.uom) || [];
                var packingList = ($scope.defaultData && $scope.defaultData.packing) || [];
                var paymentList = ($scope.defaultData && $scope.defaultData.paymentTypes) || $scope.paymentOptions;
                var serviceValue = findMatchingOptionValue($scope.dataOutbound.service, distServices, ['ServiceCode']);
                var uomValue = findMatchingOptionValue($scope.dataOutbound.uom, uomList, ['UOMCode']);
                var packingValue = findMatchingOptionValue($scope.dataOutbound.packing, packingList, ['PackingName']);
                var paymentValue = findMatchingOptionValue($scope.dataOutbound.payment_type, paymentList, ['PaymentName']);

                $scope.dataOutbound.modtrans = normalizeEnumValue($scope.dataOutbound.modtrans, 'AIR');
                $scope.dataOutbound.paket = normalizeEnumValue($scope.dataOutbound.paket, 'P');
                $scope.dataOutbound.payment_type = normalizeEnumValue(paymentValue || $scope.dataOutbound.payment_type || derivePaymentType($scope.dataOutbound.type) || 'CREDIT');
                $scope.dataOutbound.collect_type = normalizeEnumValue($scope.dataOutbound.collect_type, 'CASH');
                $scope.dataOutbound.type = deriveOutboundType($scope.dataOutbound.payment_type, $scope.dataOutbound.type);
                $scope.dataOutbound.service = serviceValue || normalizeTextValue($scope.dataOutbound.service) || getPreferredOptionValue(distServices, ['ServiceCode'], 'REG');
                $scope.dataOutbound.uom = uomValue || normalizeTextValue($scope.dataOutbound.uom) || getFirstOptionValue(uomList, ['UOMCode']);
                $scope.dataOutbound.packing = packingValue || normalizeTextValue($scope.dataOutbound.packing) || getFirstOptionValue(packingList, ['PackingName']);

                if (['CASH', 'COLLECT'].indexOf($scope.dataOutbound.collect_type) < 0) {
                    $scope.dataOutbound.collect_type = 'CASH';
                }
                if ($scope.item && $scope.item.editIndex < 0 && (!$scope.item.dataItem.uom || canonicalizeOptionValue($scope.item.dataItem.uom) === canonicalizeOptionValue($scope.dataOutbound.uom))) {
                    $scope.item.dataItem.uom = $scope.dataOutbound.uom || '';
                }
            }

            function applyDefaultSelections() {
                if (!$scope.defaultData) {
                    return;
                }
                if (!$scope.isEdit && !$scope.dataOutbound.service && $scope.defaultData.distServices && $scope.defaultData.distServices.length > 0) {
                    $scope.dataOutbound.service = getPreferredOptionValue($scope.defaultData.distServices, ['ServiceCode'], 'REG');
                }
                if (!$scope.isEdit && !$scope.dataOutbound.uom && $scope.defaultData.uom && $scope.defaultData.uom.length > 0) {
                    $scope.dataOutbound.uom = $scope.defaultData.uom[0].UOMCode;
                }
                if (!$scope.isEdit && !$scope.dataOutbound.packing && $scope.defaultData.packing && $scope.defaultData.packing.length > 0) {
                    $scope.dataOutbound.packing = $scope.defaultData.packing[0].PackingName;
                }
                if (!$scope.isEdit && !$scope.dataOutbound.payment_type) {
                    $scope.dataOutbound.payment_type = 'CREDIT';
                }
                if (!$scope.isEdit && !$scope.dataOutbound.type) {
                    $scope.dataOutbound.type = deriveOutboundType($scope.dataOutbound.payment_type);
                }
                reconcileOutboundSelections();
            }

            function getCurrentAwb() {
                return normalizeAwbValue($scope.dataOutbound.awb || $scope.originalAwb || ($scope.currentAwbStatus && $scope.currentAwbStatus.awb));
            }

            function recalculateCharges() {
                var shipment = roundCurrencyValue($scope.dataOutbound.charge_shipment);
                var packing = roundCurrencyValue($scope.dataOutbound.charge_packing);
                var insurance = roundCurrencyValue($scope.dataOutbound.charge_insurance);
                var discount = roundCurrencyValue($scope.dataOutbound.discount);
                var subTotal = shipment + packing + insurance;
                var vat = normalizeNumberValue($scope.dataOutbound.is_ppn) ? roundCurrencyValue(Math.max(subTotal - discount, 0) / 100) : 0;

                $scope.dataOutbound.sub_total = subTotal;
                $scope.dataOutbound.vat = vat;
                $scope.dataOutbound.total = subTotal - discount + vat;
            }

            function hasShipmentChargeLookupInputs() {
                return !!(
                    normalizeTextValue($scope.dataOutbound.shipper_code) &&
                    normalizeTextValue($scope.dataOutbound.org_code) &&
                    normalizeTextValue($scope.dataOutbound.dest_code) &&
                    normalizeTextValue($scope.dataOutbound.uom) &&
                    normalizeTextValue($scope.dataOutbound.service) &&
                    normalizeTextValue($scope.dataOutbound.modtrans) &&
                    Math.max(normalizeNumberValue($scope.dataOutbound.weight), normalizeNumberValue($scope.dataOutbound.weight_metrik)) > 0
                );
            }

            function applyAutoShipmentCharge(result) {
                if (!result || !result.found || $scope.isChargeShipmentManual) {
                    return;
                }
                $scope.dataOutbound.charge_shipment = roundCurrencyValue(result.charge_shipment);
                recalculateCharges();
            }

            function lookupShipmentCharge() {
                var query;

                if ($scope.suspendShipmentChargeLookup || !hasShipmentChargeLookupInputs()) {
                    return;
                }

                query = [
                    'shipper_code=' + encodeURIComponent(normalizeTextValue($scope.dataOutbound.shipper_code)),
                    'org_code=' + encodeURIComponent(normalizeTextValue($scope.dataOutbound.org_code)),
                    'dest_code=' + encodeURIComponent(normalizeTextValue($scope.dataOutbound.dest_code)),
                    'uom=' + encodeURIComponent(normalizeTextValue($scope.dataOutbound.uom)),
                    'service=' + encodeURIComponent(normalizeTextValue($scope.dataOutbound.service)),
                    'modtrans=' + encodeURIComponent(normalizeTextValue($scope.dataOutbound.modtrans)),
                    'weight=' + encodeURIComponent(normalizeNumberValue($scope.dataOutbound.weight)),
                    'weight_metrik=' + encodeURIComponent(normalizeNumberValue($scope.dataOutbound.weight_metrik))
                ].join('&');

                urlServices.ambilData(config.chargePreviewUrl + '?' + query, {}, function (e, o) {
                    if (e || !o) {
                        return;
                    }
                    applyAutoShipmentCharge(o);
                });
            }

            function scheduleShipmentChargeLookup() {
                if (shipmentChargeLookupTimer) {
                    window.clearTimeout(shipmentChargeLookupTimer);
                }
                shipmentChargeLookupTimer = window.setTimeout(function () {
                    shipmentChargeLookupTimer = null;
                    lookupShipmentCharge();
                }, 200);
            }

            function normalizeDeleteAuthorization(defaultData) {
                if (!defaultData) {
                    return false;
                }
                if ($scope.isEWaybillMode) {
                    return !!(defaultData.canDeleteEWaybill || defaultData.canDeleteOutbound);
                }
                return !!defaultData.canDeleteOutbound;
            }

            function setOutboundData(data) {
                $scope.dataOutbound = angular.extend({}, data || {});
            }

            function applyValueToElement(element, value) {
                var normalizedValue;
                var hasMatchingOption;

                if (!element) {
                    return 0;
                }

                if (String(element.tagName || '').toUpperCase() === 'SELECT') {
                    normalizedValue = value === undefined || value === null ? '' : String(value);
                    hasMatchingOption = normalizedValue === '' || Array.prototype.some.call(element.options || [], function (option) {
                        return String(option.value || '') === normalizedValue;
                    });

                    if (!hasMatchingOption) {
                        return 0;
                    }
                }

                element.value = value === undefined || value === null ? '' : value;
                element.dispatchEvent(new Event('input', { bubbles: true }));
                element.dispatchEvent(new Event('change', { bubbles: true }));
                return 1;
            }

            function syncControlValue(modelName, value, elementId) {
                var elements = document.querySelectorAll('[ng-model="' + modelName + '"]');
                var touched = 0;

                angular.forEach(elements, function (element) {
                    touched += applyValueToElement(element, value);
                });

                if (elementId) {
                    touched += applyValueToElement(document.getElementById(elementId), value);
                }

                return touched;
            }

            function runOutboundDomSync() {
                syncControlValue('dataOutbound.awb', $scope.dataOutbound.awb, 'awb');
                syncControlValue('dataOutbound.type', $scope.dataOutbound.type);
                syncControlValue('dataOutbound.po', $scope.dataOutbound.po, 'refno');
                syncControlValue('dataOutbound.pu_date', formatControlDateValue($scope.dataOutbound.pu_date, true), 'pickup_date');
                syncControlValue('dataOutbound.agen', $scope.dataOutbound.agen, 'agen');
                syncControlValue('dataOutbound.pu_code', $scope.dataOutbound.pu_code, 'pickup_id');
                syncControlValue('dataOutbound.org_code', $scope.dataOutbound.org_code);
                syncControlValue('dataOutbound.org_name', $scope.dataOutbound.org_name);
                syncControlValue('dataOutbound.dest_code', $scope.dataOutbound.dest_code);
                syncControlValue('dataOutbound.dest_name', $scope.dataOutbound.dest_name);
                syncControlValue('dataOutbound.service', $scope.dataOutbound.service);
                syncControlValue('dataOutbound.shipper_code', $scope.dataOutbound.shipper_code, 'pengirim_id');
                syncControlValue('dataOutbound.shipper_name', $scope.dataOutbound.shipper_name, 'pengirim_nama');
                syncControlValue('dataOutbound.shipper_address', $scope.dataOutbound.shipper_address, 'pengirim_alamat');
                syncControlValue('dataOutbound.shipper_contact', $scope.dataOutbound.shipper_contact, 'pengirim_pic');
                syncControlValue('dataOutbound.shipper_phone', $scope.dataOutbound.shipper_phone, 'pengirim_telp');
                syncControlValue('dataOutbound.shipper_fax', $scope.dataOutbound.shipper_fax, 'pengirim_fax');
                syncControlValue('dataOutbound.shipper_inst', $scope.dataOutbound.shipper_inst, 'shipper_instruction');
                syncControlValue('dataOutbound.severity', $scope.dataOutbound.severity, 'severity');
                syncControlValue('dataOutbound.consign_name', $scope.dataOutbound.consign_name, 'penerima_nama');
                syncControlValue('dataOutbound.consign_address', $scope.dataOutbound.consign_address, 'penerima_alamat');
                syncControlValue('dataOutbound.consign_phone', $scope.dataOutbound.consign_phone, 'penerima_telp');
                syncControlValue('dataOutbound.consign_fax', $scope.dataOutbound.consign_fax, 'penerima_fax');
                syncControlValue('dataOutbound.consign_postcode', $scope.dataOutbound.consign_postcode, 'kode_post');
                syncControlValue('dataOutbound.reffno3', $scope.dataOutbound.reffno3, 'reffno3');
                syncControlValue('dataOutbound.consign_attn', $scope.dataOutbound.consign_attn, 'attention_to');
                syncControlValue('dataOutbound.isi', $scope.dataOutbound.isi, 'penerima_keterangan');
                syncControlValue('dataOutbound.modtrans', $scope.dataOutbound.modtrans);
                syncControlValue('dataOutbound.weight', $scope.dataOutbound.weight, 'berat_id');
                syncControlValue('dataOutbound.uom', $scope.dataOutbound.uom);
                syncControlValue('dataOutbound.collie', $scope.dataOutbound.collie, 'qty_id');
                syncControlValue('dataOutbound.weight_metrik', $scope.dataOutbound.weight_metrik, 'berat_metrikid');
                syncControlValue('dataOutbound.packing', $scope.dataOutbound.packing);
                syncControlValue('dataOutbound.paket', $scope.dataOutbound.paket);
                syncControlValue('dataOutbound.payment_type', $scope.dataOutbound.payment_type);
                syncControlValue('dataOutbound.collect_type', $scope.dataOutbound.collect_type);
                syncControlValue('dataOutbound.charge_shipment', $scope.dataOutbound.charge_shipment);
                syncControlValue('dataOutbound.charge_packing', $scope.dataOutbound.charge_packing);
                syncControlValue('dataOutbound.charge_insurance', $scope.dataOutbound.charge_insurance);
                syncControlValue('dataOutbound.sub_total', $scope.dataOutbound.sub_total);
                syncControlValue('dataOutbound.discount', $scope.dataOutbound.discount);
                syncControlValue('dataOutbound.vat', $scope.dataOutbound.vat);
                syncControlValue('dataOutbound.total', $scope.dataOutbound.total);
                syncControlValue('dataOutbound.awb_date', formatControlDateValue($scope.dataOutbound.awb_date, false), 'tglshipment');
            }

            function syncOutboundFormFields() {
                [0, 100, 300].forEach(function (delay) {
                    window.setTimeout(function () {
                        runOutboundDomSync();
                    }, delay);
                });
            }

            function mapOutboundMaster(master) {
                return {
                    awb: master.AWB || master.awb || '',
                    awb_date: getSafeDateValue(master.AWB_Date || master.awb_date),
                    pu_date: getSafeDateValue(master.PU_Date || master.pu_date || master.PU_Time || master.pu_time, master.AWB_Date || master.awb_date),
                    type: deriveOutboundType(master.Payment || master.payment, master.Type || master.type),
                    po: master.PO || master.po || '',
                    org_code: master.Org_Code || master.org_code || 'JKT',
                    org_name: master.Org_Name || master.org_name || 'JAKARTA',
                    org_host_code: master.Org_Host_Code || master.org_host_code || master.Org_Code || master.org_code || 'JKT',
                    org_host_name: master.Org_Host_Name || master.org_host_name || master.Org_Name || master.org_name || 'JAKARTA',
                    dest_code: master.Dest_Code || master.dest_code || '',
                    dest_name: master.Dest_Name || master.dest_name || '',
                    dest_host_code: master.Dest_Host_Code || master.dest_host_code || '',
                    dest_host_name: master.Dest_Host_Name || master.dest_host_name || '',
                    agen: master.Agen || master.agen || '',
                    pu_code: master.PU_Code || master.pu_code || '',
                    shipper_code: master.Shipper_Code || master.shipper_code || '',
                    shipper_name: master.Shipper_Name || master.shipper_name || '',
                    shipper_address: master.Shipper_Address || master.shipper_address || '',
                    shipper_phone: master.Shipper_Phone || master.shipper_phone || '',
                    shipper_fax: master.Shipper_Fax || master.shipper_fax || '',
                    shipper_contact: master.Shipper_Contact || master.shipper_contact || '',
                    shipper_inst: master.Shipper_Inst || master.shipper_inst || '',
                    consign_name: master.Consign_Name || master.consign_name || '',
                    consign_address: master.Consign_Address || master.consign_address || '',
                    consign_phone: master.Consign_Phone || master.consign_phone || '',
                    consign_fax: master.Consign_Fax || master.consign_fax || '',
                    consign_postcode: master.Consign_PostCode || master.consign_postcode || '',
                    reffno3: master.ReffNo3 || master.reffno3 || ($scope.isEWaybillMode ? (master.Consign_Fax || master.consign_fax || '') : ''),
                    consign_attn: master.Consign_Attn || master.consign_attn || '',
                    modtrans: master.ModTrans || master.modtrans || 'AIR',
                    service: normalizeTextValue(master.Service || master.service),
                    weight: normalizeNumberValue(master.Weight || master.weight),
                    collie: normalizeNumberValue(master.Collie || master.collie),
                    uom: normalizeTextValue(master.UOM || master.uom),
                    packing: normalizeTextValue(master.Packing || master.packing),
                    paket: normalizeEnumValue(master.Paket || master.paket || 'P'),
                    severity: normalizeEnumValue(master.Severity || master.severity || 'NORMAL'),
                    weight_metrik: roundMetricValue(master.Weight_Metrik || master.weight_metrik || master.Volume || master.volume),
                    isi: master.Isi || master.isi || '',
                    payment_type: normalizeEnumValue(master.Payment || master.payment || derivePaymentType(master.Type || master.type) || 'CREDIT'),
                    collect_type: normalizeEnumValue(master.CollectCash || master.collect_cash || 'CASH'),
                    shipment_cat: master.Shipment_Cat || master.shipment_cat || 'DOMESTICS',
                    shipment_tipe: master.Shipment_Tipe || master.shipment_tipe || 'OUTBOUND',
                    insurance: (master.IsInsurance || master.is_insurance) ? 1 : 0,
                    kode_dok: master.KodeDok || master.kode_dok || master.kodedok || '',
                    lembar_dok: normalizeNullableNumberValue(master.LembarDok || master.lembar_dok || master.lembardok),
                    shipper_idr: normalizeNullableNumberValue(master.ShipperIDR || master.shipper_idr || master.shipperidr),
                    is_ppn: (master.ISPPN || master.is_ppn) ? 1 : 0,
                    l: normalizeNumberValue(master.L || master.l),
                    w: normalizeNumberValue(master.W || master.w),
                    h: normalizeNumberValue(master.H || master.h),
                    charge_shipment: roundCurrencyValue(master.Charge_Shipment || master.charge_shipment),
                    charge_packing: roundCurrencyValue(master.Charge_packing || master.charge_packing),
                    charge_insurance: roundCurrencyValue(master.Charge_Insurance || master.charge_insurance),
                    sub_total: roundCurrencyValue(master.SubTotal || master.sub_total),
                    discount: roundCurrencyValue(master.Discount || master.discount),
                    vat: roundCurrencyValue(master.VAT || master.vat),
                    total: roundCurrencyValue(master.Total || master.total),
                    isvendor: (master.IsVendor || master.isvendor) ? 1 : 0,
                    vendorname: master.VendorName || master.vendorname || ''
                };
            }

            function hasMasterLikeFields(candidate) {
                return !!(candidate && typeof candidate === 'object' && (
                    candidate.AWB || candidate.awb || candidate.Shipper_Name || candidate.shipper_name ||
                    candidate.Consign_Name || candidate.consign_name || candidate.Dest_Name || candidate.dest_name
                ));
            }

            function hasDetailLikeFields(candidate) {
                return !!(candidate && typeof candidate === 'object' && (
                    candidate.ItemCode || candidate.item_code || candidate.Description || candidate.desc || candidate.SN || candidate.sn
                ));
            }

            function hasVolumeLikeFields(candidate) {
                return !!(candidate && typeof candidate === 'object' && (
                    candidate.Weight_Metric || candidate.weight_metric || candidate.weightMetric || candidate.NoOfCollie || candidate.noOfCollie || candidate.P || candidate.p
                ));
            }

            function findNestedMatch(source, matcher, depth, visited) {
                var keys;
                var index;
                var result;

                if (!source || depth > 5) {
                    return null;
                }
                if (typeof source !== 'object') {
                    return null;
                }
                if (visited.indexOf(source) >= 0) {
                    return null;
                }
                visited.push(source);

                if (matcher(source)) {
                    return source;
                }

                if (angular.isArray(source)) {
                    for (index = 0; index < source.length; index += 1) {
                        result = findNestedMatch(source[index], matcher, depth + 1, visited);
                        if (result) {
                            return result;
                        }
                    }
                    return null;
                }

                keys = Object.keys(source);
                for (index = 0; index < keys.length; index += 1) {
                    result = findNestedMatch(source[keys[index]], matcher, depth + 1, visited);
                    if (result) {
                        return result;
                    }
                }

                return null;
            }

            function findNestedArray(source, matcher, depth, visited) {
                var keys;
                var index;
                var value;
                var result;

                if (!source || depth > 5) {
                    return null;
                }
                if (typeof source !== 'object') {
                    return null;
                }
                if (visited.indexOf(source) >= 0) {
                    return null;
                }
                visited.push(source);

                if (angular.isArray(source) && source.length > 0 && matcher(source[0])) {
                    return source;
                }

                if (angular.isArray(source)) {
                    for (index = 0; index < source.length; index += 1) {
                        result = findNestedArray(source[index], matcher, depth + 1, visited);
                        if (result) {
                            return result;
                        }
                    }
                    return null;
                }

                keys = Object.keys(source);
                for (index = 0; index < keys.length; index += 1) {
                    value = source[keys[index]];
                    if (angular.isArray(value) && value.length > 0 && matcher(value[0])) {
                        return value;
                    }
                    result = findNestedArray(value, matcher, depth + 1, visited);
                    if (result) {
                        return result;
                    }
                }

                return null;
            }

            function normalizeMasterDetailResponse(response) {
                var normalizedResponse = response || {};
                var rawMaster = normalizedResponse.master || normalizedResponse.Master || normalizedResponse.header || normalizedResponse.Header || normalizedResponse.data || normalizedResponse.Data || normalizedResponse;
                var directMaster = angular.isArray(rawMaster) ? (rawMaster[0] || {}) : (rawMaster || {});
                var master = hasMasterLikeFields(directMaster) ? directMaster : (findNestedMatch(normalizedResponse, hasMasterLikeFields, 0, []) || {});
                var detail = normalizedResponse.detail || normalizedResponse.Detail || normalizedResponse.details || normalizedResponse.Details || findNestedArray(normalizedResponse, hasDetailLikeFields, 0, []) || [];
                var volume = normalizedResponse.volume || normalizedResponse.Volume || normalizedResponse.volumes || normalizedResponse.Volumes || findNestedArray(normalizedResponse, hasVolumeLikeFields, 0, []) || [];
                if (!angular.isArray(detail)) {
                    detail = detail ? [detail] : [];
                }
                if (!angular.isArray(volume)) {
                    volume = volume ? [volume] : [];
                }

                return {
                    master: master,
                    detail: detail,
                    volume: volume
                };
            }

            function applyMasterDetailResponse(response, awb) {
                var normalizedResponse = normalizeMasterDetailResponse(response);
                var master = normalizedResponse.master;
                var mappedMaster = mapOutboundMaster(master);
                var detailRows = normalizedResponse.detail;
                var volumeRows = normalizedResponse.volume;

                $scope.isEdit = true;
                $scope.isWeightMetricManual = false;
                $scope.isChargeShipmentManual = true;
                $scope.originalAwb = normalizeAwbValue(awb);
                lastLookupAwb = normalizeAwbValue(mappedMaster.awb || awb);
                setOutboundData(mappedMaster);
                reconcileOutboundSelections();
                if (!$scope.dataOutbound.awb) {
                    $scope.dataOutbound.awb = normalizeAwbValue(awb);
                }
                $scope.detailItem = detailRows.map(normalizeDetailItem);
                resequenceDetailItems();
                refreshVolumeRows(volumeRows.map(normalizeVolumeRow));
                $scope.item.dataItem = createEmptyItem($scope.detailItem.length + 1);
                $scope.item.editIndex = -1;
                $scope.isReadOnly = !!Number(master.Manifest || 0);
                $scope.currentAwbStatus = {
                    awb: master.AWB || awb,
                    isManifest: !!Number(master.Manifest || 0),
                    statusCode: master.StatusCode || '',
                    statusName: master.StatusName || '',
                    manifestNo: master.manifest_no || master.Manifest_No || ''
                };
                recalculateCharges();
                syncOutboundFormFields();
            }

            function buildExistingAwbMessage(status) {
                if (status && status.isManifest) {
                    return 'AWB tersebut sudah di manifest';
                }
                return 'AWB tersebut sudah di entry';
            }

            function requestGeneratedAwb(callback, silent) {
                var paymentType;
                var shipperCode;
                var typeValue;

                if (!$scope.isEWaybillMode || $scope.isEdit) {
                    if (callback) {
                        callback();
                    }
                    return;
                }

                paymentType = normalizeEnumValue($scope.dataOutbound.payment_type || derivePaymentType($scope.dataOutbound.type), 'CREDIT');
                shipperCode = normalizeTextValue($scope.dataOutbound.shipper_code);
                typeValue = deriveOutboundType(paymentType, $scope.dataOutbound.type);

                if (!shipperCode) {
                    $scope.dataOutbound.awb = '';
                    setAutoAwbState(false, 'Id Pengirim harus dipilih sebelum generate AWB');
                    if (!silent) {
                        setFormNotice('warning', 'Id Pengirim harus dipilih sebelum generate AWB');
                        toaster.pop('warning', config.entryLabel, 'Id Pengirim harus dipilih sebelum generate AWB');
                    }
                    if (callback) {
                        callback('Id Pengirim harus dipilih sebelum generate AWB');
                    }
                    return;
                }

                urlServices.ambilData(config.generateAwbUrl + '?payment_type=' + encodeURIComponent(paymentType) + '&type=' + encodeURIComponent(typeValue) + '&shipper_code=' + encodeURIComponent(shipperCode) + '&preview_number=1', {}, function (e, o) {
                    var generatedAwb;

                    if (e) {
                        $scope.dataOutbound.awb = '';
                        setAutoAwbState(false, e.err || e || 'Nomor AWB otomatis gagal dibuat');
                        if (!silent) {
                            setFormNotice('danger', e.err || e || 'Nomor AWB otomatis gagal dibuat');
                            toaster.pop('error', config.entryLabel, e.err || e || 'Nomor AWB otomatis gagal dibuat');
                        }
                        if (callback) {
                            callback(e);
                        }
                        return;
                    }

                    generatedAwb = normalizeAwbValue(o && o.awb);
                    $scope.isAutoNumber = true;
                    $scope.dataOutbound.awb = generatedAwb;
                    $scope.originalAwb = null;
                    lastLookupAwb = generatedAwb || null;
                    setAutoAwbState(!!generatedAwb, generatedAwb ? '' : 'Nomor AWB otomatis gagal dibuat');
                    syncOutboundFormFields();

                    if (callback) {
                        callback(null, generatedAwb);
                    }
                });
            }

            function buildPayload() {
                recalculateVolumeTotals({ preserveManual: true });
                recalculateCharges();

                return angular.extend({}, $scope.dataOutbound, {
                    awb: ($scope.isEWaybillMode && !$scope.isEdit) ? '' : normalizeAwbValue($scope.dataOutbound.awb),
                    original_awb: ($scope.isEWaybillMode && !$scope.isEdit) ? '' : ($scope.originalAwb || normalizeAwbValue($scope.dataOutbound.awb)),
                    awb_date: serializeDateValue($scope.dataOutbound.awb_date, false),
                    pu_date: serializeDateValue($scope.dataOutbound.pu_date, true),
                    consign_postcode: normalizeTextValue($scope.dataOutbound.consign_postcode),
                    reffno3: normalizeTextValue($scope.dataOutbound.reffno3),                    
                    kode_dok: normalizeTextValue($scope.dataOutbound.kode_dok),
                    lembar_dok: normalizeNullableNumberValue($scope.dataOutbound.lembar_dok),
                    shipper_idr: normalizeNullableNumberValue($scope.dataOutbound.shipper_idr),
                    is_edit: $scope.isEdit,
                    auto_generate_awb: $scope.isEWaybillMode && !$scope.isEdit ? 1 : 0,
                    is_e_waybill: $scope.isEWaybillMode ? 1 : 0,
                    charge_shipment_manual: $scope.isChargeShipmentManual ? 1 : 0,
                    type: deriveOutboundType($scope.dataOutbound.payment_type, $scope.dataOutbound.type),
                    payment_type: normalizeEnumValue($scope.dataOutbound.payment_type || derivePaymentType($scope.dataOutbound.type), 'CREDIT'),
                    collect_type: normalizeEnumValue($scope.dataOutbound.collect_type, 'CASH'),
                    detail: ($scope.detailItem || []).map(function (item, index) {
                        var normalized = normalizeDetailItem(item, index);

                        if (!normalized.sn) {
                            normalized.sn = String(index + 1);
                        }
                        return normalized;
                    }),
                    volume: ($scope.volumeRows || []).map(function (row, index) {
                        return serializeVolumeRow(row, index);
                    })
                });
            }

            $scope.item = {
                dataItem: createEmptyItem(1),
                editIndex: -1,
                addItem: function () {
                    var nextIndex = $scope.item.editIndex >= 0 ? $scope.item.editIndex : $scope.detailItem.length;
                    var normalizedItem = normalizeDetailItem(angular.extend({}, $scope.item.dataItem, {
                        sn: $scope.item.dataItem.sn || String(nextIndex + 1),
                        uom: $scope.item.dataItem.uom || $scope.dataOutbound.uom || ''
                    }), nextIndex);

                    if (!normalizedItem.item_code && !normalizedItem.desc) {
                        return toaster.pop('error', config.entryLabel, 'Item code atau description harus diisi');
                    }

                    if ($scope.item.editIndex >= 0) {
                        $scope.detailItem[$scope.item.editIndex] = normalizedItem;
                    } else {
                        $scope.detailItem.push(normalizedItem);
                    }

                    resequenceDetailItems();
                    $scope.item.dataItem = createEmptyItem($scope.detailItem.length + 1);
                    $scope.item.editIndex = -1;
                },
                editItem: function (index, item) {
                    $scope.item.editIndex = index;
                    $scope.item.dataItem = normalizeDetailItem(angular.copy(item), index);
                },
                deleteItem: function (index) {
                    $scope.detailItem.splice(index, 1);
                    resequenceDetailItems();
                    if ($scope.item.editIndex === index) {
                        $scope.item.dataItem = createEmptyItem($scope.detailItem.length + 1);
                        $scope.item.editIndex = -1;
                    }
                }
            };

            $scope.onVolumeRowChange = function (index) {
                var row = normalizeVolumeRow($scope.volumeRows[index] || {}, index);

                $scope.isWeightMetricManual = false;
                $scope.isChargeShipmentManual = false;
                row.awb = normalizeAwbValue($scope.dataOutbound.awb);
                row.collie = normalizeNumberValue($scope.dataOutbound.collie) || row.collie || $scope.volumeRows.length;
                row.noOfCollie = row.noOfCollie || (index + 1);
                row.weightMetric = calculateWeightMetric(row);
                $scope.volumeRows[index] = row;
                recalculateVolumeTotals();
            };

            $scope.onWeightMetricManualChange = function () {
                $scope.isWeightMetricManual = true;
                $scope.isChargeShipmentManual = false;
                $scope.dataOutbound.weight_metrik = roundMetricValue($scope.dataOutbound.weight_metrik);
            };

            $scope.onChargeShipmentManualChange = function () {
                $scope.isChargeShipmentManual = true;
            };

            $scope.showListAgen = function () {
                modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                    functionName: 'agenList',
                    params: {}
                });
            };

            $scope.showListCustomer = function (isReceiver) {
                if (isReceiver && !$scope.allowReceiverCustomerLookup) {
                    return;
                }

                modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                    functionName: 'customerList',
                    params: {
                        isReceiver: isReceiver,
                        customerListUrl: isReceiver ? config.receiverCustomerListUrl : config.shipperCustomerListUrl
                    }
                });
            };

            $scope.showListCourier = function () {
                modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                    functionName: 'courierList',
                    params: {}
                });
            };

            $scope.showListKota = function (isFrom) {
                modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                    functionName: 'cityList',
                    params: {
                        isFrom: isFrom
                    }
                });
            };

            $scope.$on('pilih-agent', function (event, args) {
                $scope.dataOutbound.agen = args.agen.KodeUser;
            });

            $scope.$on('pilih-courier', function (event, args) {
                $scope.dataOutbound.pu_code = args.CourierCode;
            });

            $scope.$on('pilih-contact', function (event, args) {
                applySelectedCustomer(args);
                return true;
            });

            $scope.onShipperCodeInputChange = function () {
                lookupShipperByCode(false);
            };

            $scope.onShipperCodeInputBlur = function () {
                if (shipperLookupTimer) {
                    $timeout.cancel(shipperLookupTimer);
                    shipperLookupTimer = null;
                }
                $scope.dataOutbound.shipper_code = normalizeCodeValue($scope.dataOutbound.shipper_code);
                if ($scope.isEWaybillMode && !$scope.isEdit) {
                    if (!$scope.dataOutbound.shipper_code) {
                        $scope.dataOutbound.awb = '';
                        setAutoAwbState(false, 'Id Pengirim harus dipilih sebelum generate AWB');
                        return;
                    }
                    lookupShipperByCode(true);
                }
            };

            $scope.onConsignCodeInputChange = function () {
                lookupConsignByCode(false);
            };

            $scope.onConsignCodeInputBlur = function () {
                if (consignLookupTimer) {
                    $timeout.cancel(consignLookupTimer);
                    consignLookupTimer = null;
                }
                $scope.dataOutbound.consign_code = normalizeCodeValue($scope.dataOutbound.consign_code);
            };

            $scope.onCityCodeInputChange = function (isFrom) {
                lookupCityByCode(isFrom, false);
            };

            $scope.onCityCodeInputBlur = function (isFrom) {
                var timerKey = isFrom ? 'origin' : 'destination';

                if (cityLookupTimers[timerKey]) {
                    $timeout.cancel(cityLookupTimers[timerKey]);
                    cityLookupTimers[timerKey] = null;
                }

                if (isFrom) {
                    $scope.dataOutbound.org_code = normalizeCodeValue($scope.dataOutbound.org_code);
                } else {
                    $scope.dataOutbound.dest_code = normalizeCodeValue($scope.dataOutbound.dest_code);
                }
            };

            $scope.$on('pilih-kota', function (event, args) {
                if (args && args.isFrom) {
                    $scope.dataOutbound.org_host_code = args.city.HostCode;
                    $scope.dataOutbound.org_host_name = args.city.HostName;
                    $scope.dataOutbound.org_code = args.city.CityCode;
                    $scope.dataOutbound.org_name = args.city.CityName;
                } else {
                    $scope.dataOutbound.dest_host_code = args.city.HostCode;
                    $scope.dataOutbound.dest_host_name = args.city.HostName;
                    $scope.dataOutbound.dest_code = args.city.CityCode;
                    $scope.dataOutbound.dest_name = args.city.CityName;
                }
                return true;
            });

            $scope.getData = function () {
                urlServices.ambilData(config.defaultDataUrl, {}, function (e, o) {
                    if (e) {
                        setFormNotice('danger', 'Default data tidak bisa dimuat');
                        return toaster.pop('error', config.entryLabel, 'Default data tidak bisa dimuat');
                    }
                    $scope.defaultData = o;
                    $scope.deleteAuthorized = normalizeDeleteAuthorization(o);
                    if (o && angular.isArray(o.paymentTypes) && o.paymentTypes.length > 0) {
                        $scope.paymentOptions = o.paymentTypes;
                    }
                    applyDefaultSelections();
                    syncOutboundFormFields();
                    if ($scope.item.editIndex < 0 && !$scope.item.dataItem.uom) {
                        $scope.item.dataItem.uom = $scope.dataOutbound.uom || '';
                    }
                });
            };

            $scope.addOutbound = function () {
                clearFormNotice();
                $scope.isReadOnly = false;
                $scope.isEdit = false;
                $scope.isAutoNumber = $scope.isEWaybillMode;
                $scope.isWeightMetricManual = false;
                $scope.isChargeShipmentManual = false;
                $scope.suspendShipmentChargeLookup = true;
                $scope.originalAwb = null;
                $scope.currentAwbStatus = null;
                lastLookupAwb = null;
                setAutoAwbState(!$scope.isEWaybillMode, $scope.isEWaybillMode ? 'Id Pengirim harus dipilih sebelum generate AWB' : '');
                setOutboundData({
                    awb: '',
                    awb_date: moment()._d,
                    pu_date: moment()._d,
                    org_code: 'JKT',
                    org_name: 'JAKARTA',
                    org_host_code: 'JKT',
                    org_host_name: 'JAKARTA',
                    modtrans: 'AIR',
                    type: 'CREDIT SALES',
                    shipper_inst: '',
                    consign_attn: '',
                    isi: '',
                    severity: 'NORMAL',
                    paket: 'P',
                    reffno3: '',
                    kode_dok: '',
                    lembar_dok: '',
                    shipper_idr: '',
                    payment_type: 'CREDIT',
                    collect_type: 'CASH',
                    shipment_cat: 'DOMESTICS',
                    shipment_tipe: 'OUTBOUND',
                    is_ppn: 0,
                    collie: 1,
                    l: 0,
                    w: 0,
                    h: 0,
                    charge_shipment: 0,
                    charge_packing: 0,
                    charge_insurance: 0,
                    discount: 0,
                    vat: 0,
                    sub_total: 0,
                    total: 0,
                    weight_metrik: 0
                });
                $scope.detailItem = [];
                $scope.item.dataItem = createEmptyItem(1);
                $scope.item.editIndex = -1;
                applyDefaultSelections();
                refreshVolumeRows([], { resetManual: true });
                recalculateCharges();
                syncOutboundFormFields();
                $scope.suspendShipmentChargeLookup = false;
                focusAwbInput();
            };

            $scope.editOutbound = function (awb, options) {
                options = options || {};
                if (!awb) {
                    if (options.onComplete) {
                        options.onComplete();
                    }
                    return;
                }
                $scope.loadingData = true;
                urlServices.ambilData(config.entryDataUrl + encodeURIComponent(awb), {}, function (e, o) {
                    $scope.loadingData = false;
                    if (e) {
                        if (options.onComplete) {
                            options.onComplete();
                        }
                        if (!options.silent) {
                            setFormNotice('danger', e.err || e || 'Data ' + config.entryLabel.toLowerCase() + ' tidak ditemukan');
                            return toaster.pop('error', config.entryLabel, e.err || e || 'Data ' + config.entryLabel.toLowerCase() + ' tidak ditemukan');
                        }
                        return;
                    }
                    $scope.$evalAsync(function () {
                        applyMasterDetailResponse(o, awb);
                        if (options.showExistingMessage) {
                            setFormNotice('info', buildExistingAwbMessage(options.status || $scope.currentAwbStatus));
                            toaster.pop('info', config.entryLabel, buildExistingAwbMessage(options.status || $scope.currentAwbStatus));
                        }
                        if (options.onComplete) {
                            options.onComplete();
                        }
                    });
                });
            };

            $scope.checkExistingAwb = function () {
                var awb = normalizeAwbValue($scope.dataOutbound.awb);

                $scope.dataOutbound.awb = awb;
                if (!awb || awb.length < 7 || $scope.isAutoNumber || $scope.isEdit || $scope.checkingAwb) {
                    return;
                }
                if (lastLookupAwb === awb) {
                    return;
                }

                lastLookupAwb = awb;
                $scope.checkingAwb = true;
                $scope.editOutbound(awb, {
                    showExistingMessage: true,
                    silent: true,
                    onComplete: function () {
                        $scope.checkingAwb = false;
                    }
                });
            };

            $scope.handleAwbKeyDown = function (event) {
                var keyCode = event ? (event.which || event.keyCode) : 0;
                if (keyCode === 13) {
                    event.preventDefault();
                    $scope.checkExistingAwb();
                }
            };

            $scope.handleAwbKeyUp = function (event) {
                var keyCode = event ? (event.which || event.keyCode) : 0;
                if (keyCode === 13) {
                    event.preventDefault();
                    $scope.checkExistingAwb();
                }
            };

            $scope.handleFormKeyDown = function (event) {
                var keyCode = event ? (event.which || event.keyCode) : 0;
                var target = event ? (event.target || event.srcElement || {}) : {};
                var tagName = String(target.tagName || '').toUpperCase();
                var inputType = String(target.type || '').toLowerCase();

                if (keyCode !== 13) {
                    return;
                }
                if ((target.id || '') === 'awb' || tagName === 'TEXTAREA' || inputType === 'button' || inputType === 'submit') {
                    return;
                }
                event.preventDefault();
            };

            $scope.clearOutbound = function () {
                lastLookupAwb = null;
                $scope.addOutbound();
            };

            $scope.cancelOutbound = $scope.clearOutbound;

            $scope.printOutbound = function () {
                var awb = getCurrentAwb();

                function openDirectPrint(mode) {
                    var printUrl = config.printUrl + '?awb=' + encodeURIComponent(awb);

                    if (mode === 'hardcopy') {
                        printUrl += '&mode=hardcopy';
                    }
                    window.open(printUrl, '_blank');
                }

                function requestControlledPrint(reason) {
                    var printWindow = window.open('about:blank', '_blank');

                    urlServices.simpanData(config.apiBaseUrl + '/' + encodeURIComponent(awb) + '/request-print', { reason: reason || '' }, function (err, result) {
                        if (err) {
                            if (printWindow && !printWindow.closed) {
                                printWindow.close();
                            }
                            setFormNotice('danger', err.err || err || 'Permintaan print gagal');
                            return toaster.pop('warning', config.entryLabel, err.err || err || 'Permintaan print gagal');
                        }
                        if (!result || !result.printUrl) {
                            if (printWindow && !printWindow.closed) {
                                printWindow.close();
                            }
                            setFormNotice('danger', 'Respons print tidak valid');
                            return toaster.pop('warning', config.entryLabel, 'Respons print tidak valid');
                        }
                        if (printWindow && !printWindow.closed) {
                            printWindow.location = result.printUrl;
                        } else {
                            window.location = result.printUrl;
                        }
                    });
                }

                function chooseReprintReason(callback) {
                    urlServices.ambilData('api/e-waybill/reprint-reasons', {}, function (reasonErr, reasonsResult) {
                        var reasons = (reasonsResult || []).filter(function (item) {
                            return item && item.reasonName;
                        });

                        if (reasonErr) {
                            return callback(reasonErr.err || reasonErr || 'Master reason print tidak dapat dimuat');
                        }
                        if (!reasons.length) {
                            return callback('Master reason print belum tersedia');
                        }

                        modalFactory.open('sm', 'modal.ewaybill-reprint-reason.html', 'modalEWaybillReprintReasonCtrl', {
                            title: 'Pilih alasan reprint e-waybill',
                            reasons: reasons
                        }).result.then(function (selection) {
                            return callback(null, selection && selection.reasonName ? selection.reasonName : '');
                        }, function () {
                            return callback(null, null);
                        });
                    });
                }

                if (!awb) {
                    setFormNotice('danger', 'No AWB tidak boleh kosong');
                    return toaster.pop('warning', config.entryLabel, 'No AWB tidak boleh kosong');
                }

                if (!$scope.isEWaybillMode) {
                    modalFactory.open('sm', 'modal.outbound-print-option.html', 'modalOutboundPrintOptionCtrl', {
                        awb: awb,
                        entryLabel: config.entryLabel
                    }).result.then(function (selection) {
                        openDirectPrint(selection && selection.mode);
                    }, function () {});
                    return;
                }

                urlServices.ambilData(config.apiBaseUrl + '/' + encodeURIComponent(awb) + '/print-status', {}, function (statusErr, statusResult) {
                    var summary = (statusResult && statusResult.summary) || {};
                    var settings = (statusResult && statusResult.settings) || {};
                    var requiresReason = Number(summary.effectiveCount || 0) > 0 && !!settings.requireReprintReason;

                    if (statusErr) {
                        return requestControlledPrint('');
                    }

                    if (requiresReason) {
                        return chooseReprintReason(function (reasonErr, reason) {
                            if (reasonErr) {
                                setFormNotice('danger', reasonErr);
                                return toaster.pop('warning', config.entryLabel, reasonErr);
                            }
                            if (reason === null) {
                                return;
                            }
                            return requestControlledPrint(reason || '');
                        });
                    }

                    return requestControlledPrint('');
                });
            };

            $scope.openEWaybillUploadModal = function () {
                if (!$scope.showUploadButton) {
                    return;
                }

                modalFactory.open('lg', 'modal.ewaybill-upload.html', 'modalEWaybillUploadCtrl', {
                    title: config.uploadModalTitle || 'Upload E-Waybill',
                    entryLabel: config.entryLabel,
                    templateUrl: config.uploadTemplateUrl,
                    precheckUrl: config.uploadPrecheckUrl,
                    uploadUrl: config.uploadUrl
                }).result.then(function (result) {
                    if (result && Number(result.successCount || 0) > 0) {
                        setFormNotice('success', (result.successCount || 0) + ' data ' + config.entryLabel + ' berhasil diupload');
                    }
                }, function () {});
            };

            $scope.deleteOutbound = function () {
                var awb = getCurrentAwb();

                if (!awb) {
                    setFormNotice('danger', 'No AWB tidak boleh kosong');
                    return toaster.pop('warning', config.entryLabel, 'No AWB tidak boleh kosong');
                }
                if (!$scope.deleteAuthorized) {
                    setFormNotice('danger', config.deleteDeniedMessage);
                    return toaster.pop('warning', config.entryLabel, config.deleteDeniedMessage);
                }
                if ($scope.isReadOnly || ($scope.currentAwbStatus && $scope.currentAwbStatus.isManifest)) {
                    setFormNotice('danger', 'AWB ini sudah di manifest dan tidak bisa dihapus');
                    return toaster.pop('warning', config.entryLabel, 'AWB ini sudah di manifest dan tidak bisa dihapus');
                }

                chooseDeleteReason('Alasan ' + config.deleteHeaderText, awb, function (reasonErr, reasonText) {
                    if (reasonErr) {
                        setFormNotice('danger', reasonErr);
                        return toaster.pop('error', config.entryLabel, reasonErr);
                    }
                    if (!reasonText) {
                        return;
                    }

                    $scope.saving = true;
                    urlServices.hapusData(config.apiBaseUrl + '/' + encodeURIComponent(awb) + '?deleteReason=' + encodeURIComponent(reasonText), {
                        reason: reasonText
                    }, function (e) {
                        $scope.saving = false;
                        if (e) {
                            setFormNotice('danger', e.err || e || 'Data gagal dihapus');
                            return toaster.pop('error', config.entryLabel, e.err || e || 'Data gagal dihapus');
                        }

                        clearFormNotice();
                        toaster.pop('success', config.entryLabel, awb + ' berhasil dihapus');
                        $scope.clearOutbound();
                    });
                });
            };

            function validateSaveRequest() {
                var textLengthError;

                if ($scope.saving || $scope.loadingData) {
                    return 'Proses masih berjalan';
                }
                if ($scope.isReadOnly) {
                    return 'AWB ini sudah di manifest dan tidak bisa diubah';
                }
                if ($scope.isAutoNumber && !$scope.isEdit && !$scope.isEWaybillMode) {
                    return 'Auto number belum diaktifkan di web';
                }
                if ($scope.isEWaybillMode && !$scope.isEdit) {
                    if (!$scope.dataOutbound.shipper_code) {
                        return 'Customer harus dipilih';
                    }
                    if (!autoAwbState.valid || !$scope.dataOutbound.awb) {
                        return autoAwbState.message || 'Nomor E-Waybill otomatis belum bisa dibuat. Periksa Id Pengirim dan prefix customer code';
                    }
                } else if (!$scope.dataOutbound.awb) {
                    return 'No AWB tidak boleh kosong';
                }
                if (!$scope.dataOutbound.org_code || !$scope.dataOutbound.dest_code) {
                    return 'Origin dan destination harus diisi';
                }
                if (!$scope.dataOutbound.shipper_code) {
                    return 'Customer harus dipilih';
                }
                if (!$scope.dataOutbound.service) {
                    return 'Service harus dipilih';
                }
                if (!$scope.dataOutbound.uom) {
                    return 'UOM harus dipilih';
                }
                textLengthError = getTextFieldLengthError();
                if (textLengthError) {
                    return textLengthError;
                }
                return null;
            }

            function executeSaveRequest() {
                var payload = buildPayload();
                var requestMethod = $scope.isEdit ? urlServices.updateData : urlServices.simpanData;
                var requestUrl = config.apiBaseUrl + ($scope.isEdit ? '?isedit=true' : '');
                var savedAwb = payload.awb;

                $scope.saving = true;
                requestMethod(requestUrl, payload, function (e, o) {
                    $scope.saving = false;
                    if (e) {
                        setFormNotice('danger', e.err || e || 'Data gagal disimpan');
                        return toaster.pop('error', config.entryLabel, e.err || e || 'Data gagal disimpan');
                    }

                    savedAwb = normalizeAwbValue((o && o.awb) || payload.awb);
                    $scope.isEdit = true;
                    $scope.originalAwb = savedAwb;
                    $scope.dataOutbound.awb = savedAwb;
                    lastLookupAwb = savedAwb;
                    refreshVolumeRows($scope.volumeRows, { preserveManual: true });
                    $scope.loadingData = true;
                    urlServices.ambilData(config.entryDataUrl + encodeURIComponent(savedAwb), {}, function (reloadErr, reloadData) {
                        $scope.loadingData = false;
                        if (reloadErr || !reloadData) {
                            setFormNotice('danger', 'Data belum bisa diverifikasi ulang. AWB ' + savedAwb + ' perlu dicek lagi');
                            return toaster.pop('error', config.entryLabel, 'Data belum bisa diverifikasi ulang. AWB ' + savedAwb + ' perlu dicek lagi');
                        }

                        applyMasterDetailResponse(reloadData, savedAwb);
                        setFormNotice('success', savedAwb + ' berhasil disimpan');
                        toaster.pop('success', config.entryLabel, savedAwb + ' berhasil disimpan');
                    });
                });
            }

            $scope.saveOutbound = function () {
                var validationMessage;
                var currentAwb;

                clearFormNotice();
                validationMessage = validateSaveRequest();
                if (validationMessage) {
                    setFormNotice('danger', validationMessage);
                    return toaster.pop('warning', config.entryLabel, validationMessage);
                }

                currentAwb = normalizeAwbValue($scope.dataOutbound.awb || $scope.originalAwb || '');
                modalService.showModal({}, {
                    closeButtonText: 'No',
                    actionButtonText: 'Yes',
                    headerText: config.saveHeaderText,
                    bodyText: 'Simpan data ' + config.entryLabel.toUpperCase() + (currentAwb ? ' ' + currentAwb : '') + '?'
                }).then(function (result) {
                    if (!result) {
                        return;
                    }
                    executeSaveRequest();
                });
            };

            $scope.simpanOutbound = $scope.saveOutbound;

            var initialAwb = normalizeAwbValue(urlServices.getUrlParameter('awb') || urlServices.getUrlParameter('cn'));

            if (initialAwb) {
                $scope.editOutbound(initialAwb);
            } else {
                $scope.addOutbound();
            }

            bindNumberInputGuards();

            $scope.$watchGroup([
                'dataOutbound.charge_shipment',
                'dataOutbound.charge_packing',
                'dataOutbound.charge_insurance',
                'dataOutbound.discount',
                'dataOutbound.is_ppn'
            ], function () {
                recalculateCharges();
            });

            $scope.$watchGroup([
                'dataOutbound.collie',
                'dataOutbound.l',
                'dataOutbound.w',
                'dataOutbound.h',
                'dataOutbound.modtrans',
                'dataOutbound.awb'
            ], function () {
                refreshVolumeRows(null, { resetManual: true });
            });

            $scope.$watch('dataOutbound.uom', function (value, oldValue) {
                if (!$scope.item || $scope.item.editIndex >= 0) {
                    return;
                }
                if (!$scope.item.dataItem.uom || canonicalizeOptionValue($scope.item.dataItem.uom) === canonicalizeOptionValue(oldValue)) {
                    $scope.item.dataItem.uom = normalizeTextValue(value);
                }
            });

            $scope.$watch('dataOutbound.awb', function (value) {
                var awb = normalizeAwbValue(value);

                if (awb !== value) {
                    $scope.dataOutbound.awb = awb;
                    return;
                }
                if (!awb) {
                    lastLookupAwb = null;
                    return;
                }
                if ($scope.isEdit || $scope.isAutoNumber || awb.length < 7) {
                    return;
                }
                $scope.checkExistingAwb();
            });

            $scope.$watchGroup([
                'dataOutbound.shipper_code',
                'dataOutbound.org_code',
                'dataOutbound.dest_code',
                'dataOutbound.uom',
                'dataOutbound.service',
                'dataOutbound.modtrans',
                'dataOutbound.weight',
                'dataOutbound.weight_metrik'
            ], function (newValues, oldValues) {
                if ($scope.suspendShipmentChargeLookup) {
                    return;
                }
                if (!oldValues || oldValues.length === 0) {
                    return;
                }
                if (angular.equals(newValues, oldValues)) {
                    return;
                }
                $scope.isChargeShipmentManual = false;
            });

            $scope.getData();
        });
    };
})(window);
